import styles from "./styles.module.css";
import { useState, useEffect } from "react";

export default function NameEdit({ name, setName }) {
  const [_name, _setName] = useState("");

  useEffect(() => {
    _setName(name);
  }, [name]);
  return (
    <input
      value={_name}
      onBlur={() => setName(_name)}
      onChange={(e) => _setName(e.target.value)}
      id={styles.nameinput}
      placeholder="name..."
    ></input>
  );
}
